import { render } from "./CollaboratorsAddView.vue?vue&type=template&id=5308a4a7"
import script from "./CollaboratorsAddView.vue?vue&type=script&lang=js"
export * from "./CollaboratorsAddView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__